import { render, staticRenderFns } from "./state_dialog_PC.vue?vue&type=template&id=3da38688&scoped=true"
import script from "./state_dialog_PC.vue?vue&type=script&lang=js"
export * from "./state_dialog_PC.vue?vue&type=script&lang=js"
import style0 from "./state_dialog_PC.vue?vue&type=style&index=0&id=3da38688&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da38688",
  null
  
)

export default component.exports